import { Flex } from '@lokalise/louis';

import styled, { css } from '@app/styled';
import { oneLineEllipsis } from '@app/styles';
import { color, radius, spacing, typography } from '@app/theme';

export const promoContainer = css`
    height: 64px;
    background-color: ${color('background.surface.middle')};
    border: 1px solid ${color('border.light')};
    border-radius: ${radius('m')};
    text-align: left;
    cursor: pointer;
    padding: 0;
    display: block;
    text-decoration: none;
`;

export const Container = styled.a`
    ${promoContainer}
`;

export const Content = styled.div`
    overflow-x: hidden;
`;

export const Wrapper = styled(Flex)`
    padding: ${spacing(3)};
`;

export const Title = styled.h6`
    ${typography('custom.descriptionMedium')};
    ${oneLineEllipsis};
    color: ${color('text.default')} !important; // on parent hover this color unexpectedly changed;
`;

export const Subtitle = styled.p`
    ${oneLineEllipsis};
    color: ${color('background.action.primary.default')};
    ${typography('custom.description')};
`;

export const Icons = styled.div`
    flex-shrink: 0;
`;

export const Icon = styled.img`
    width: 30px;
    height: 30px;
    padding: 3px;
`;
